<template>
  <div class="form-submit-button">
    <button
      type="submit"
      @click="handleSubmit"
      :disabled="disabled"
      :style="{
        backgroundColor: tourSettings.theme_color,
        color: tourSettings.theme_text_color
      }"
      :class="[
        'flex mx-auto my-5 py-2 px-6 rounded-full ',
        disabled ? 'opacity-40' : 'opacity-100'
      ]"
    >
      {{ displayButtonText }}
    </button>
    
    <!-- Message display for stay action -->
    <div v-if="message" class="mt-2 p-2 bg-yellow-100 border border-yellow-400 text-yellow-700 rounded">
      {{ message }}
    </div>
  </div>
</template>

<script>
import { showMultiLingualText } from '../../utils/languageUtils'
import {mapGetters} from "vuex";

export default {
  name: 'FormSubmitButton',
  props: {
    block: {
      type: Object,
      required: false,
      default: null
    },
    form: {
      type: Object,
      default: () => ({})
    },
    disabled: {
      type: Boolean,
      default: false
    },
    isPageLocked: {
      type: Boolean,
      default: false
    },
    message: {
      type: String,
      default: ''
    },
    buttonText: {
      type: String,
      default: 'Submit'
    }
  },
  computed: {
    ...mapGetters('settings', ['tourSettings']),
    displayButtonText() {
      // If block is provided, use its button text, otherwise use the prop
      if (this.block?.data?.button_text) {
        return showMultiLingualText(this.block.data.button_text, 'Send', false, this.$i18n.locale)
      }
      return this.buttonText
    }
  },
  methods: {
    handleSubmit(event) {
      event.preventDefault()
      
      // Create a synthetic event object with form data
      const syntheticEvent = {
        target: {
          name: 'form_submit_button',
          value: this.form
        },
        formData: this.form,
        block: this.block
      }
      
      this.$emit('submit', syntheticEvent)
    }
  }
}
</script> 